export const industryIcons = {
    'Automotive': {
        'icon': 'car-solid',
        'color': '#B11313'
    },
    'Computer Services': {
        'icon': 'laptop-solid',
        'color': '#4B475C'
    },
    'Financial': {
        'icon': 'money-bill-wave-solid',
        'color': '#216831'
    },
    'Health and Beauty': {
        'icon': 'suitcase-medical-solid',
        'color': '#552D6D'
    },
    'Home Improvement': {
        'icon': 'home-improvement',
        'color': '#532D0A'
    },
    'Home Services': {
        'icon': 'home-services',
        'color': '#198C8C'
    },
    'Insurance': {
        'icon': 'insurance',
        'color': '#D3770D'
    },
    'Legal': {
        'icon': 'scale-balanced-solid',
        'color': '#085A93'
    },
    'Personal Services': {
        'icon': 'user-solid',
        'color': '#FF4F4F'
    },
    'Real Estate': {
        'icon': 'real-estate',
        'color': '#9D2265'
    },
}

export const industryIconFillColor = {
    automotive: "#B11313",
    computerServices: "#4B475C",
    financial: "#216831",
    healthAndBeauty: "#552D6D",
    homeImprovement: "#532D0A",
    homeServices: "#198C8C",
    insurance: "#D3770D",
    legal: "#085A93",
    personalServices: "#FF4F4F",
    realEstate: "#9D2265",
    filter: '#B11313',
    expand: '#B11313'
};

export const industryIconNames = {
    automotive: "automotive",
    computerServices: "computerServices",
    financial: "financial",
    healthAndBeauty: "healthAndBeauty",
    homeImprovement: "homeImprovement",
    homeServices: "homeServices",
    insurance: "insurance",
    legal: "legal",
    personalServices: "personalServices",
    realEstate: "realEstate",
    filter: "filter",
    expand: "expand"
};

export const industryIconLogos = {
    automotive: "car-solid",
    computerServices: "laptop-solid",
    financial: "money-bill-wave-solid",
    healthAndBeauty: "suitcase-medical-solid",
    homeImprovement: "home-improvement",
    homeServices: "home-services",
    insurance: "insurance",
    legal: "scale-balanced-solid",
    personalServices: "user-solid",
    realEstate: "real-estate",
};